module.exports = __webpack_public_path__ + "static/media/2020-UIL-State-7-person-panel-Adjudication-Sheets.f2085c73.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/20-21/2020-UIL-State-7-person-panel-Adjudication-Sheets.pdf
// module id = 197
// module chunks = 0